// extracted by mini-css-extract-plugin
module.exports = {"container":"_16e863","title":"_7f0aea","description":"_36bd8c","cta":"_c7a48f","imageContainer":"_7a8b83","image":"_534b30","icon":"_ffe26d"};